import { GET_HOME_PAGE_DETAILS } from "../../Utils/types";

const initialState = {
  getHomePageDetails: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HOME_PAGE_DETAILS:
      return {
        ...state,
        getHomePageDetails: action.payload,
      };
    default:
      return state;
  }
};
